/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const RepeatIcon = /*#__PURE__*/ createSvgIcon(
  'RepeatIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.415 5.612a5.649 5.649 0 012.086 4.654c.01.153.008.306-.002.459-.099 1.393-.665 2.597-1.633 3.451C16.9 15.028 15.57 15.5 14 15.5H5v-1h9c1.37 0 2.45-.409 3.204-1.074.752-.663 1.215-1.614 1.297-2.771a2.49 2.49 0 000-.35l-.002-.03.002-.031a4.649 4.649 0 00-1.716-3.856l.63-.776z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.707 15l2.647-2.646-.708-.707L4.293 15l3.353 3.354.708-.707L5.707 15zM2.134 5.83C3.099 4.973 4.429 4.5 6 4.5v1c-1.369 0-2.45.41-3.204 1.078-.75.665-1.213 1.615-1.297 2.768v.033l-.003.106a3.2 3.2 0 00.003.22l.002.03-.002.03a4.65 4.65 0 001.716 3.847l-.63.776A5.65 5.65 0 01.5 9.743a4.519 4.519 0 010-.39v-.036l.001-.01v-.014l.001-.008c.099-1.393.665-2.6 1.633-3.456zM6 5v.5h9v-1H6.001L6 5z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.293 5l-2.647-2.646.707-.708L15.707 5l-3.354 3.354-.707-.708L14.293 5z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default RepeatIcon;
